import {
  Text,
  NoData,
  TitleComponent,
  CustomTag,
} from "ui-components";
import { HorizontalCard, Amount, Label } from "../../components/common";
import TeamProfile from "../../components/team-profile";
import { CompanyType, ManagementT } from "ui-io/company-io";
import { calculateFundingAmount, getLatestEmployeeCount } from "../../utils";
import { Colors } from "@blueprintjs/core";

type Props = {
  currentCompany?: CompanyType;
};

const CompanyOverview = (props: Props) => {
  const { currentCompany } = props;
  return (
    <>
      <TitleComponent>Description</TitleComponent>
      <div className="max-w-90 fs-16 lh-1pt4 mt-sm">
        {currentCompany?.description || "N/A"}
      </div>

      <div className="mt-md">
        {currentCompany?.tags &&
          currentCompany?.tags.map((highlight: string, index: number) => (
            <CustomTag  bgColor={Colors.BLUE3} color={Colors.WHITE} key={index}>{highlight}</CustomTag>
          ))}
      </div>

      <div className="mt-xlg">
        <TitleComponent>Timeline</TitleComponent>
        <Text className="mb-md mt-sm">Headcount & Funding</Text>

        <div className="display-flex justify-between align-center gap-3">
          <HorizontalCard avatarIcon={"/images/total-funding.svg"}>
            <Amount className="mt-xs">
              £
              {currentCompany?.funding_rounds?.length &&
                calculateFundingAmount(currentCompany.funding_rounds)}
            </Amount>
            <Label>Funding Total</Label>
          </HorizontalCard>
          <HorizontalCard avatarIcon={"/images/users.svg"}>
            <Amount className="mt-xs">
              {currentCompany?.emp_count?.length &&
                `${getLatestEmployeeCount(currentCompany.emp_count)}+`}
            </Amount>
            <Label>Headcount</Label>
          </HorizontalCard>
          <HorizontalCard avatarIcon={"/images/investments.svg"}>
            <Amount className="mt-xs">
              {currentCompany?.funding_rounds &&
                currentCompany?.funding_rounds.length}
            </Amount>
            <Label>Investments</Label>
          </HorizontalCard>
        </div>
        {/* <div className="pt-xxlg  mr-lg mb-md">
          <HeadCountChart
                    data={data}
                    labels={labels}
                    funding={funding}
                    stage={stage}
                  />
        </div> */}
      </div>
      <div className="pt-md">
        <TitleComponent>Management team</TitleComponent>
        {currentCompany?.management && currentCompany.management?.length > 0
          ? currentCompany.management.map((management: ManagementT) => (
              <TeamProfile
                name={management.name}
                linkedin={management?.linkedin}
                position={management?.position}
                profileImage={management?.profileImage}
                emailId={management?.email}
              />
            ))
          : <NoData title="No data available" description="No higher management found; our bot is verifying availability."/>}
      </div>
    </>
  );
};

export default CompanyOverview;
